import {Injectable} from '@angular/core';
import {SecureApi} from '../core/secure.api';

@Injectable()
export class PatientRegistrationService {
    constructor(public secureApi: SecureApi) {
    }

    register(data, clinicId) {
        return this.secureApi.post('patients/registration/' + clinicId, data, false);
    }

    getClinicTemplate(clinicId) {
        return this.secureApi.get('b2c-patients/clinic-template/' + clinicId);
    }
}
